export default "<form novalidate> <h2 class=modal-header>Release Notes</h2> <div class=main-table-w> <div class=row> <div class=\"large-12 columns\"> <div> <b>Title:</b>{{vm.title}} </div> <br> <div ng-bind-html=vm.description> <!-- <b>Description:</b>\r\n             <ul>\r\n              <li ng-repeat=\"item in vm.getDescriptionList() track by $index\"> {{ item }} </li>\r\n            </ul> --> </div> <div class=\"right dialog-footer\"> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </div> </form> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/header/openReleaseNotes.tpl.html
// module id = 418
// module chunks = 0